import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { z } from 'zod';
import { SurveysPage } from '@/features/surveys';

const SurveyTabSchema = z.enum(['overview', 'submit', 'questions', 'responses', 'settings']);

const SurveysSearchSchema = z.object({
  tab: SurveyTabSchema.optional(),
});

export const Route = createFileRoute('/surveys')({
  component: SurveysRoute,
  validateSearch: (search) => SurveysSearchSchema.parse(search),
});

function SurveysRoute(): ReactNode {
  const search = Route.useSearch();
  return <SurveysPage {...(search.tab !== undefined ? { tab: search.tab } : {})} />;
}
